import React from 'react'
import { Provider } from 'react-redux'
import { initStore } from './initStore'
import { userIsAdmin } from 'lib/utils'

export const store = initStore()

if (userIsAdmin) {
  window.reduxStore = store
}

export const HasDataProviderContext = React.createContext(false)

export const DataProvider = (props) => (
  <HasDataProviderContext.Provider value>
    <Provider {...props} store={store} />
  </HasDataProviderContext.Provider>
)
